import React from 'react';
import { Navbar } from '../components/Navbar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { IndustryDatabaseLinks } from '../components/IndustryDatabaseLinks';
import { Footer } from '../components/Footer';
import { AccountingHero } from '../components/accounting/AccountingHero';
import { AccountingDataPreview } from '../components/accounting/AccountingDataPreview';
import { AccountingFields } from '../components/accounting/AccountingFields';
import { AccountingValueProps } from '../components/accounting/AccountingValueProps';
import { AccountingWorkflow } from '../components/accounting/AccountingWorkflow';
import { AccountingCityLinks } from '../components/accounting/AccountingCityLinks';
import { AccountingUseCases } from '../components/accounting/AccountingUseCases';
import { AccountingFAQ } from '../components/accounting/AccountingFAQ';
import { AccountingCta } from '../components/accounting/AccountingCta';
import { DatabaseIcon, BookOpenIcon, ScaleIcon } from 'lucide-react';
// Custom related links for the accounting page
const accountingRelatedLinks = [{
  title: 'Local business owner finder',
  description: 'Find verified business owner contacts with emails and phones.',
  href: '#/owner-finder',
  cta: 'Explore feature',
  type: 'Feature',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Email sequencing',
  description: 'Launch multi-step email campaigns directly from the platform.',
  href: '#/email-sequencing',
  cta: 'Explore feature',
  type: 'Feature',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'How to book more meetings using free outreach tools',
  description: 'Proven templates and strategies for outbound email.',
  href: 'https://openmart.com/blogs/how-to-book-more-meetings-using-free-outreach-tools-and-proven-templates',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'How to sell to local businesses',
  description: 'Strategies for targeting and closing local SMBs.',
  href: 'https://openmart.com/blogs/how-to-sell-to-local-business',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Using the Openmart API to fetch data',
  description: 'Integrate the Openmart API into your application.',
  href: 'https://openmart.com/product-tutorials/using-the-openmart-api-to-fetch-data',
  cta: 'Read tutorial',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Openmart vs ZoomInfo',
  description: 'Compare executive data coverage and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-zoominfo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
// Industry database links for accounting page
const accountingIndustryLinks = [{
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians with verified owner contacts.',
  href: 'https://openmart.com/data/doctors',
  count: '180K+'
}, {
  title: 'Dentist contacts database',
  description: 'Find dental practices with verified owner emails and phones.',
  href: 'https://openmart.com/data/dentists',
  count: '150K+'
}, {
  title: 'Lawyer contacts database',
  description: 'Connect with law firms and attorneys across the US.',
  href: 'https://openmart.com/data/lawyers',
  count: '200K+'
}, {
  title: 'Real estate agent database',
  description: 'Reach real estate agents and brokers with verified details.',
  href: 'https://openmart.com/data/real-estate-agents',
  count: '300K+'
}, {
  title: 'Restaurant owner database',
  description: 'Access restaurant owners and managers nationwide.',
  href: 'https://openmart.com/data/restaurants',
  count: '500K+'
}, {
  title: 'Property management database',
  description: 'Find property management companies with verified contacts.',
  href: 'https://openmart.com/data/property-management',
  count: '120K+'
}];
export function AccountingDatabase() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6306">
      <Navbar data-id="element-6307" />
      <main data-id="element-6308">
        <AccountingHero data-id="element-6309" />
        <AccountingDataPreview data-id="element-6310" />
        <AccountingFields data-id="element-6311" />
        <AccountingValueProps data-id="element-6312" />
        <AccountingWorkflow data-id="element-6313" />
        <AccountingCityLinks data-id="element-6314" />
        <AccountingUseCases data-id="element-6315" />
        <AccountingFAQ data-id="element-6316" />
        <IndustryDatabaseLinks currentIndustry="accounting" links={accountingIndustryLinks} data-id="element-6317" />
        <RelatedFeatures features={accountingRelatedLinks} data-id="element-6318" />
        <AccountingCta data-id="element-6319" />
      </main>
      <Footer data-id="element-6320" />
    </div>;
}